import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { KnowHowDocumentsModel } from '../models/documents/know-how-documents.model';
import { KnowHowDocumentsDocumentModel } from '../models/documents/know-how-documents-document.model';

@Injectable({
    providedIn: 'root',
})

export class KnowHowService {

    constructor(private httpClient: HttpClient) { }

    getDocuments(): Observable<KnowHowDocumentsModel> {
        return this.httpClient.get<KnowHowDocumentsModel>(`${environment.api}/knowhow/documents`);
    }

    getDocumentDetailsById(documentId: string): Observable<KnowHowDocumentsDocumentModel> {
        return this.httpClient.get<KnowHowDocumentsDocumentModel>(`${environment.api}/knowhow/documents/${documentId}`);
    }

    downloadDocumentFile(documentId: string): Observable<Blob> {
        return this.httpClient.get(`${environment.api}/knowhow/documents/${documentId}/download`, { responseType: 'blob', observe: 'response' }
        ).pipe(map(resp => {
            // if needed the filename can also be returned
            // const contentDisposition = resp.headers.get('Content-Disposition') ?? '';
            // const fileNameMatch = /filename\*?=(?:UTF-8''|")?([^\";]+)/i.exec(contentDisposition);
            // const fileName = fileNameMatch ? decodeURIComponent(fileNameMatch[1].replace(/"/g, '')) : 'download';

            return resp.body as Blob;
        }));
    }

    // use this for direct file download
    getDocumentUrl(documentId: string): string {
        return `${environment.api}/knowhow/documents/${documentId}/download`;
    }

    markDocumentAsRead(documentId: string): Observable<void> {
        return this.httpClient.post<void>(`${environment.api}/knowhow/documents/${documentId}/markAsRead`, null);
    }


}